export default __webpack_public_path__ + "static/media/delivery-home.5a00ebca.svg";